import React from "react";
import { ServiceDetail, ServicesList, Page404 } from "./../../components";
import "./service-detail-view.css";
import { getDemoById } from "./../../list";

export default function() {
  const demoName = window.location.pathname.split("/")[2];
  let ServiceDetails = getDemoById(demoName);

  if (ServiceDetails) {
    return (
      <div className="service-detail-container">
        <ServiceDetail {...ServiceDetails} />
        { (!ServiceDetails || !ServiceDetails.underConstruction) &&
          <ServicesList activeOne={ServiceDetails.title} />
        }
      </div>
    );
  }
  else {
    return <Page404 />
  }
  

}
